/**
 * Validation Utility File
 *
 * @exports utils/validation
 * @category Utils
 */

/**
 * Evaluate the passed domain value and confirm if it is a valid domain.
 *
 * @param {string} value
 * @returns {boolean}
 */
export const validateDomain = (value) => {
  const expression = new RegExp(/^((?=[a-z0-9-]{1,63}\.)[a-z0-9-]+(-[a-z0-9-]+)*\.)+[a-z]{2,63}$/);

  return value.match(expression);
};
/**
 * Evaluate the passed value and domains to confirm if it is a valid email domain name. The domains that are passed should not include the @ symbol (Ex: ['acme.com', 'unum.com']).
 *
 * @param {string} value
 * @param {Array} domains
 * @returns {boolean}
 */
export const validateEmailDomain = (value, domains = []) => {
  const extension = value && value.includes('@')
    ? value.split('@')[1].toLowerCase()
    : null;

  return domains.find((domain) => domain.toLowerCase() === extension) !== undefined;
};

export default {
  validateDomain,
  validateEmailDomain,
};
